module.exports = __webpack_public_path__ + "img/Vijay-Vojhala-by-Kaunain-Sheriff-Indian-Express.0fd96786.jpg";